import { createTheme } from "@mui/material/styles";

export type ModoTema = "claro" | "escuro";

const fontFamily = ["Nunito", "sans-serif", "Roboto", "Helvetica", "Arial"].join(",");

// Paletas do XC WMS, para manter a mesma identidade visual entre os produtos
export const criarTema = (modo: ModoTema = "claro") =>
  modo === "escuro"
    ? createTheme({
        palette: {
          mode: "dark",
          primary: { main: "#ffffff" },
          secondary: { main: "#f48fb1" },
          error: { main: "#cf6679" },
          background: { default: "#28243D", paper: "#3C384F" },
          text: { primary: "#ffffff" },
        },
        typography: { fontFamily },
      })
    : createTheme({
        palette: {
          mode: "light",
          primary: { main: "#28243D" },
          secondary: { main: "#19857b" },
          error: { main: "#ff0000" },
          background: { default: "#E5E5EA", paper: "#F6F6F7" },
          text: { primary: "#000" },
        },
        typography: { fontFamily },
      });
